import QuotationCartService from '../../../../shared/services/quotation_cart_service.js'
import ShoppingCartService from '../../../../shared/services/shopping_cart_service.js'
import QuantityPicker from '../product/quantity-picker.vue'

export default {
  components: {
    QuantityPicker,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },

    isQuotation: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      selectedVariantId: null,
      quantity: 1,
      cartService: null,
      isProcessing: false,
    }
  },

  computed: {
    isOutOfStock() {
      if (this.isQuotation) return false
      return this.variant.stock < 1
    },

    isVariantsLoaded() {
      return typeof this.selectedVariantId === 'string'
    },

    isPurchasable() {
      return this.selectedVariant && this.selectedVariant.stock > 0
    },

    subTotal() {
      return this.toMoney(this.selectedVariant.consumer_price).multiply(this.quantity)
    },

    masterVariant() {
      return this.variants.find((variant) => variant.is_master === true)
    },

    currentStock() {
      return this.selectedVariant.stock || 0
    },
  },

  mounted() {
    // console.log('please add `this._initializeCartService()` to mounted hook.')
  },

  methods: {
    _initializeCartService() {
      if (this.isQuotation) return (this.cartService = new QuotationCartService(this.$vlf, this.$store))
      this.cartService = new ShoppingCartService(this.$vlf, this.$store)
    },

    addToQuotationCart() {
      console.log('please implement method `#addToQuotationCart` in component.')
    },

    quoteNow() {
      console.log('please implement method `#quoteNow` in component.')
    },

    addToCart() {
      console.log('please implement method `#addToCart` in component.')
    },

    buyNow() {
      console.log('please implement method `#buyNow` in component.')
    },

    _callAddToQuotationCartMethod() {
      this.isProcessing = true

      return this.cartService.addListToCart(this.requestBody).then(() => {
        return this.$store.dispatch('addFlashMessage', [
          'success',
          this.messageLocaleText('product_added_to_quotation_cart_successfully'),
        ])
      })
    },

    _callAddToCartMethod() {
      this.isProcessing = true

      return this.cartService
        .addItemToCart(this.requestBody)
        .then(() => {
          return this.$store.dispatch('addFlashMessage', [
            'success',
            this.messageLocaleText('product_added_to_cart_successfully'),
          ])
        })
        .then((_) => {
          return this._tracingAddToCartEvent()
        })
    },

    _tracingAddToCartEvent() {
      return this.$store
        .dispatch('gaOperation', [
          [
            'ec:addProduct',
            {
              id: this.selectedVariant.sku,
              name: this.selectedVariant.product_name,
              brand: this.product.brand_name,
              variant: this.selectedVariant.name,
              price: this.toMoney(this.selectedVariant.consumer_price).amount,
              quantity: this.quantity,
            },
          ],
          ['ec:setAction', 'add'],
          [
            'send',
            {
              hitType: 'event',
              eventCategory: 'Ecommerce',
              eventAction: 'Add to Cart',
            },
          ],
        ])
        .then((_) => {
          return this.$store.dispatch('pixelOperation', [
            [
              'track',
              'AddToCart',
              {
                content_ids: this.selectedVariant.sku,
                content_name: this.selectedVariant.product_name,
                content_type: 'Product',
                currency: 'TWD',
                value: this.toMoney(this.selectedVariant.consumer_price).amount,
                quantity: this.quantity,
              },
            ],
          ])
        })
    },
  },
}
